import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppBase } from '../app-base';
import { UserService } from './user.service';
import { Observable } from 'rxjs/Observable';
import { CurrentUser } from '../models/current-user.model';

@Injectable()
export class AuthGuard extends AppBase implements CanActivate {
  constructor(private _router: Router,
              private _userService: UserService) {
    super();
  }

  checkCurrentUserInfo(user: CurrentUser, url: string): Observable<string> {
    // this.currentUser = user;

    return new Observable<string>((observer) => {
      this._userService.getCurrentUserInfo()
        .subscribe(
          data => {
            if (user && user.community_id && data.community_id && (user.community_id !== data.community_id)) {
              observer.next('currentCommunityHasChanged');
            } else {
              observer.next('ok');
            }
          },
          err => {
            if (err.status === 404) {
              // Parche para el problema con Heroku en que a veces retorna 'No such App'
              observer.next('ok');
            } else {
              observer.next('currentUserNotLoggedIn');
            }
          },
          () => {
            observer.complete();
          }
        );
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // this.initStorage();
    if (!this.currentUser) {
      this._router.navigate(['/auth']);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts